import {Base} from "@/api/Base"

export class MpfSettingList extends Base {
    path = "mpfSetting/list"
}